import { useQuery } from "@apollo/client"
import { Link, useParams } from "react-router-dom"
import { gql } from "~/__generated__"
import { GraphqlError } from "~/ui/errors"
import { useDocumentTitle } from "~/common/use-document-title"
import { ScreenLoading } from "~/ui/screen-loading"
import { columns } from "./columns"
import { DataTable } from "~/admin/data-table"
import { AddSubscriberForm } from "./add-subscriber-form"
import { myLettermemeManagePath } from "~/common/paths"

const lettermemeSubscriptionsQuery = gql(/* GraphQL */ `
  query LettermemeSubscriptions($lettermemeId: ID!) {
    lettermemeSubscriptions(lettermemeId: $lettermemeId) {
      userId
      lettermemeId
      isUnsubscribed
      unsubscribedAt
      createdAt
      user {
        id
        email
      }
    }
  }
`)

export const SubscribersScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { data, error, loading } = useQuery(lettermemeSubscriptionsQuery, {
    variables: { lettermemeId: id! },
    skip: !id,
  })

  useDocumentTitle("Subscribers")

  if (error) return <GraphqlError error={error} />
  if (loading) return <ScreenLoading />

  const subscriptions = data?.lettermemeSubscriptions ?? []

  return (
    <div className="mx-auto max-w-7xl p-8">
      <div className="mb-8">
        <Link to={myLettermemeManagePath({ id: id! })} className="text-gray-400">
          ← back to lettermeme settings
        </Link>
        <h1 className="mt-4 text-2xl font-bold">Subscribers</h1>
        <p className="text-gray-400">Users subscribed to this lettermeme</p>
      </div>
      <div className="mb-8">
        <AddSubscriberForm lettermemeId={id!} />
      </div>
      <DataTable columns={columns} data={subscriptions} />
    </div>
  )
}
